module.exports = __webpack_public_path__ + "static/logo2-7c74571cfe675fac7b3deeedd9993679.svg";